import updateOrderItemDocument from './updateOrderItemDocument'
import validateFile from './validateFile'
import updateFile from './updateFile'

const manageDocumentChange = async ({
  event,
  setImgErrorMessage,
  setDisplayImgUploadError,
  showErrorMessage,
  allowImg,
  getBase64,
  reduceImageResolution,
  setDocSteps,
  removedReqSel,
  setReqElem,
  documentLibraryTypes,
  orderItems,
  oidIndex,
  setUploadPayload,
  putSignedUrl,
  applicationData,
  fileUpload,
  setSelectedDocs,
  selectedDocs,
  setFilesUpload,
  filesUpload,
  formFile,
  setFormFile,
  setFileUpload,
}) => {
  const { target } = event

  try {
    const {
      errorMessage,
      content,
      ext,
    } = validateFile({
      target,
      setImgErrorMessage,
      setDisplayImgUploadError,
      showErrorMessage,
      allowImg,
    })

    if (errorMessage !== '') {
      throw new Error(errorMessage)
    }

    const {
      sku,
      required,
      files,
    } = await updateFile({
      content,
      getBase64,
      allowImg,
      ext,
      reduceImageResolution,
      formFile,
      target,
    })

    setDocSteps(prev => {
      const updateSteps = {
        ...prev,
        [sku]: [
          ...(prev[`${sku}`] || []).filter(x => x.id !== target.id) || [],
          { id: target.id, type: content.type },
        ],
      }

      if ((updateSteps[`${sku}`] || []).length >= 3 || !required) {
        removedReqSel('documentLibrary')
      } else if ((updateSteps[`${sku}`] || []).length < 3 && required) {
        setReqElem(prev2 => [...prev2.filter(x => x.id !== 'documentLibrary'), documentLibraryTypes])
      }
      updateOrderItemDocument({
        orderItems,
        oidIndex,
        sku,
        content,
        target,
      })

      const docData = {
        id: target.id,
        type: content.type,
      }

      const payload = setUploadPayload(orderItems, applicationData, 'document', docData, sku)
      putSignedUrl(payload, 'documents').then(res => {
        const newUploadFilePayload = { ...fileUpload }
        Object.assign(newUploadFilePayload, {
          [sku]: {
            ...newUploadFilePayload[`${sku}`] || {},
            [target.id]: res,
          },
        })

        setSelectedDocs({ ...selectedDocs, [sku]: files })
        setFilesUpload({
          ...filesUpload,
          [sku]: {
            ...filesUpload[`${sku}`] || {},
            [target.id]: res,
          },
        })
        setFormFile(files)
        setFileUpload(newUploadFilePayload)
      })

      return updateSteps
    })
  } catch (error) {
    delete target.value
  }
}

export default manageDocumentChange
